import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { FeedsService } from 'src/app/shared/services/feeds/feeds.service';
import { SessionMgmtService } from 'src/app/shared/services/session-mgmt/session-mgmt.service';
import { LtmsEventHandlerService } from 'src/app/shared/services/ltms-event-handler/ltms-event-handler.service';
import { LWEventsExecutor } from 'src/app/shared/services/lw-ui-rule/lw-event-executor';
import { FileUploadService } from 'src/app/shared/services/file-upload/file-upload.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { environment } from 'src/environments/environment';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { CommonService } from 'src/app/shared/services/lw-ui-rule/common.service';
import { LwActionsExecutor } from 'src/app/shared/services/lw-ui-rule/lw-action-executor';
import { LtmsDataSource } from 'src/app/shared/services/lw-ui-rule/ltms-data-source';
import { LwComponentRenderer } from 'src/app/shared/services/lw-elements-renderer/lw-component-renderer';
import { NgFor, NgIf, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DomSanitizer  } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
@Component({
    selector: 'app-chat-panel',
    templateUrl: './chat-panel.component.html',
    styleUrls: ['./chat-panel.component.scss'],
    imports: [NgFor, NgIf, FormsModule, DatePipe]
})
export class ChatPanelComponent implements OnInit {
  @Input() feedId: string = "";
  @Input() replyBackAllowed: boolean = false;
  @Input() brandDetails: any = {};
  @Input() feedData: any = {};
  @Input() customerDetails: any = {};
  destroyRef = inject(DestroyRef);
  doNotShow: boolean = false;
  showAlertMessage: boolean = false
  fileList: any = [];
  comments: any = [];
  isSocial: boolean = false;
  feedDetails: any = {};
  feedById: string = "";
  conversationProfiles: any = {}
  replying: boolean = false;
  replyType: string = "2";
  discussions: any = {}
  files: any = [];
  params: any = {};
  loginResponse: any = {};
  isInternalComment: boolean = false;
  comment: string = "";
  message: string = "Maximum 5 files should be upload at once"
  showNotification: boolean = false;
  feedAttachmentEnabled: boolean = false;
  isAttachmentEnabled: boolean = false;
  messageToSend: any = {};
  allowedFileTypes: any = ['jpg', 'jpeg', 'png', 'pdf', 'docx', 'xls', 'xlsx', 'doc', 'csv'];
  allowedExtension: any = ".jpg,.jpeg,.png,.pdf,.docx,.xls,.xlsx,.doc,.csv";
  undotime: any = 15000
  undotimeText: string = "30 sec to 1 min"
  serviceToPass: any = {}
  constructor(
    private _feedService: FeedsService,
    private _session: SessionMgmtService,
    private _ltmsEvent: LtmsEventHandlerService,
    private ltmsEventExecutor: LWEventsExecutor,
    private _fileUpload: FileUploadService,
    private _utils: UtilsService,
    private _helpers: HelpersService,
    private commonService: CommonService,
    private LwActionsExecutor: LwActionsExecutor,
    private LtmsDataSource: LtmsDataSource,
    private lwComponentRenderer: LwComponentRenderer,
    private _domSanitizer: DomSanitizer,
  ) {
    this.serviceToPass = {
      _helpers: this._helpers,
      LtmsDataSource: this.LtmsDataSource,
      lwComponentRenderer: this.lwComponentRenderer,
      _utils: this._utils,
      _uploadService: this._fileUpload,
      _feedService: this._feedService,
      LwActionsExecutor: this.LwActionsExecutor,
      _ltmsEvent: this._ltmsEvent,
      _domSanitizer:this._domSanitizer,
      SecurityContext: SecurityContext
    }
  }
  ngOnInit(): void {

  }
  ngOnChanges() {
    this.prepareData()
  }

  prepareData() {
    this.loginResponse = _.get(Helpers, 'managerDetails', {});

    if (!_.isEmpty(this.brandDetails) && _.hasIn(this.feedData, 'feed') && !_.isEmpty(this.feedData.feed)) {
      this.feedById = _.get(this.feedData, 'feed.feed_by_id', '');
      this.feedDetails = _.get(this.feedData, 'feed')
      this.conversationProfiles = {
        "requester_name": _.get(this.brandDetails, "reply_from_text"),
        "requested_date": _.get(this.feedData, "feed.feedback_request_date"),
        "requester_photoUrl": _.get(this.brandDetails, "reply_from_logo"),
        "responder_name": _.get(this.feedData, "feed.customerName"),
        "responded_date": _.get(this.feedData, "feed.created_date"),
        "responder_id": _.get(this.feedData, "feed.customerId"),
      }
      let webhookEnabled = (_.hasIn(this.brandDetails, 'comment.webhook') || (_.hasIn(this.brandDetails, 'comment.webhooks') && !_.isEmpty(this.brandDetails.comment.webhooks))) ? true : false;
      let isActionWorkflowEnabled = _.get(this.brandDetails, 'is_action_workflow_enabled', false);
      this.replyBackAllowed = ((webhookEnabled || isActionWorkflowEnabled) && this.replyBackAllowed);
      this.feedAttachmentEnabled = _.get(this.brandDetails, 'feed_attachment_enabled', false)
      this.isAttachmentEnabled = this._helpers.checkAccessByFeature("feed_attachment_enabled", this.loginResponse.manager.manager_access, this.feedData, this.brandDetails);
      this.undotime = _.get(this.brandDetails, "action_management_configuration.widget_settings.chat.undo_time_in_ms", 15000);
      this.undotimeText = this.getUndoTimeString(this.undotime);
      this.prepareCommentsDetail(this.feedData)
    }
  }

  prepareCommentsDetail(data) {
    var usersList = _.union(data.managers, data.users);
    var userDetail = _.filter(_.get(data, "users", []), { "_id": this.feedById });
    let comments = _.get(data, 'feed.comments', []);
    usersList = _.map(usersList, (user: any) => {
      if (user && user._id === data.feed._id) {
        const userData = _.get(this.feedData, "feed.user.name");
        user.phone_number = (userData.phone_number) ? userData.phone_number : 'NA';
        user.email_address = (userData.email_address) ? userData.email_address : 'NA';
      }
      return user
    });
    var defaultLogo = 'img/avatars/male.png';

    if (_.hasIn(data, "feed.comments")) {
      comments = comments.sort((a: any, b: any) => {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(a.created_date).getTime() - new Date(b.created_date).getTime();
      });
    }

    this.comments = _.map(comments, (comment: any) => {
      // const tempdata = _.each(comments, (comment: any) => {
      const user = _.find(usersList, { _id: comment.commented_by_id });
      if (!_.isEmpty(user)) {
        comment.user = user;
        if (comment.commented_by_type == 2 && this.brandDetails) {
          if (this.brandDetails.reply_from_text) {
            comment.user.name = this.brandDetails.reply_from_text;
          }
          if (this.brandDetails.reply_from_logo) {
            comment.user.photo_url = this.brandDetails.reply_from_logo;
          } else {
            comment.user.photo_url = defaultLogo;
          }
        } else {
          comment.user.photo_url = defaultLogo;
        }
      }
      if (!_.isEmpty(comment.attachments)) {
        comment.attachments = this.prepareAttatchmentDetails(comment.attachments)
      }
      if (!comment.commented_by_id) {
        comment.user = userDetail;
        if (comment.user) {
          comment.user.photo_url = defaultLogo;
        }
        if (comment.commented_by_type == 1) {
          if (Helpers.restrictedBrandsForCustomerNames.indexOf(this.brandDetails._id) != -1) {
            comment.user.name = 'Anonymous';
          }
        } else if (comment.commented_by_type == 2 && this.brandDetails) {
          if (this.brandDetails.reply_from_text) {
            comment.user.name = this.brandDetails.brand.reply_from_text;
          }
          if (this.brandDetails.reply_from_logo) {
            comment.user.photo_url = this.brandDetails.reply_from_logo;
          }
        }
      }
      return comment
    });
    const element:any = document.getElementById('ltms-chat-messages');
    if(element){
      setTimeout(() => {
        element.scroll({ top: element.scrollHeight, behavior: 'smooth' });
      }, 100);
    }
  }

  prepareAttatchmentDetails(attachments) {
    return _.map(attachments, (attachment: any) => {
      const attachmentPath = (typeof attachment != 'string' && attachment.value && attachment.value != '')?attachment.value : attachment;
      const nameArray = attachmentPath.split("/");
      const name = nameArray[nameArray.length - 1]
      const extArr = name.split(".");
      const ext = extArr[extArr.length - 1];
      return {
        name: nameArray[nameArray.length - 1].replace("." + ext, ""),
        ext: "." + ext,
        value: attachment,
      }
    })
  }

  updateAttatchment(event: any) {
    let tempList = this.fileList
    tempList = tempList.concat(Array.from(event.target.files));
    if (tempList.length < 6) {
      if (!this.isFileSizeExceed(tempList)) {
        if (this.checkFileType(tempList, this.allowedFileTypes)) {
          this.fileList = this.fileList.concat(Array.from(event.target.files))
          event.target.value = '';
          setTimeout(() => {
            const footer = document.getElementById('ltms-chat-footer');
            const body = document.getElementById('ltms-chat-history')
            if (footer && body) {
              const footerRect = footer.getBoundingClientRect();
              body.style.height = 'calc(100% - ' + footerRect.height + 'px)'
            }
          }, 30);
        } else {
          this.notification("Unsupported File Type")
        }
      } else {
        this.notification("Maximum file size cannot exceed 3mb")
      }
    } else {
      event.target.value = '';
      this.notification("Maximum 5 files should be upload.")
    }
  }

  isFileSizeExceed(files) {
    for (var j = 0; j < files.length; j++) {
      if ((files[j].size / 1024 / 1024) > 3) {
        return true;
      }
    }
    return false;
  }

  checkFileType(files, allowedFileTypes) {
    for (var i = 0; i < files.length; i++) {
      var filename = files[i].name;
      var temp = filename.split('.');
      var ext = temp[temp.length - 1];
      if (ext) {
        if (!files[i]['type']) {
          files[i]['type-one'] = ext.toLowerCase();
        }
        if (!(allowedFileTypes.indexOf(ext.toLowerCase()) >= 0)) {
          return false;
        }
      }
    }
    return true;
  }

  notification(message: string) {
    this.message = message;
    this.showNotification = true;
    setTimeout(() => {
      this.showNotification = false;
    }, 3000);
  }

  undoComment(comment: any) {
    this.comments = _.map(this.comments, (message: any) => {
      if (message._id === comment._id) {
        message.isNewComment = false;
        message.is_deleted = true;
      }
      return message
    });
  }

  isSentButtonEnabled: boolean = false;
  onCommentChange(event: any) {
    event.preventDefault();
    let comment = this.comment.trim();
    if (comment && comment != '') {
      this.isSentButtonEnabled = true
    } else {
      this.comment = ''
      this.isSentButtonEnabled = false
    }
  }

  commentPost(comment) {
    this.replying = true;
    this.isSentButtonEnabled = false

    var comments = {};
    comments['comment'] = comment;
    this.comment = ''
    if (this.isInternalComment) {
      comments['is_internal'] = true;
    }
    var feedDetail = this.feedDetails;
    feedDetail.tags = _.get(this.feedDetails, "litmus_processed_data") ? _.get(this.feedDetails, "litmus_processed_data") : {};
   
    var brandDetail = Helpers.brandDetails || this.brandDetails;
    feedDetail.brandDetails = Helpers.deepClone(brandDetail);
    // var ltmsEventExecutor = new LWEventsExecutor()
    if (brandDetail && brandDetail.hasOwnProperty('is_action_workflow_enabled') && brandDetail.is_action_workflow_enabled) {
      this.ltmsEventExecutor.execute("LW_COMMENT_ADDED", Helpers.deepClone(feedDetail), this.serviceToPass, (err, success) => {
        if (!err) {
          this.postComment(comments);
        } else {
          this.comment = ""
        }
      })
    } else {
      this.postComment(comments);
    }
  }

  postComment(comments: any) {

    this.geturl((urlArray: any) => { //get S3 bucket URl for the selected files
      if (urlArray) {
        comments['attachments'] = urlArray;
      }
      this.messageToSend = comments;
      var shouldConfirm: any = localStorage.getItem("show_response_reply_confirmation");
      shouldConfirm = shouldConfirm == true || shouldConfirm == "true";
      if (!shouldConfirm) {
        this.showAlertMessage = true;
      } else {
        this.sendMessage()
      }

    })
  }

  setData() {
    this.feedId = this.discussions._id;
    this.comment = '';
    this.files = [];
    //for attachment component send parameters
    this.params = {
      "is_multi": true,
      "max_number_of_files ": 2
    };
    // lwFeedConversationVm.smoothScroll()
  }

  geturl(cb) {
    if (this.fileList && this.fileList.length > 0) {
      var urlArray: any = [];
      const promises: any = [];
      for (let i = 0; i < this.fileList.length; i++) {
        promises.push(
          new Promise((resolve) => {
            this._feedService.uploadFilesInS3(this.fileList[i], this.brandDetails._id).pipe(
              takeUntilDestroyed(this.destroyRef)
            ).subscribe((response: any) => {
              if (_.hasIn(response, 'data.file_id') || _.hasIn(response, 'data.url')) {
                if (_.hasIn(response, 'data.url')) {
                  resolve(response.data.url);
                } else if (_.hasIn(response, 'data.file_id')) {
                  resolve(response.data.file_id);
                }
              } else {
                resolve(null);
              }
            });
          })
        )

      }
      Promise.all(promises).then((response: any) => {
        cb(response)
      })
    } else {
      cb(null)
    }
  }

  cancelMessage() {
    this.showAlertMessage = false;
  }

  sendMessage() {
    this.showAlertMessage = false;
    if (this.doNotShow) {
      localStorage.setItem("show_response_reply_confirmation", "true");
    }
    var comment = Helpers.hasProperty(this.messageToSend, "comment") ? this.messageToSend.comment : null;
    var attachments = Helpers.hasProperty(this.messageToSend, "attachments") ? this.messageToSend.attachments : null;
    if (comment && comment.trim().length > 0) {
      const input: any = document.getElementById('litmus-chat-attatchment');
      if (input) {
        input.value = '';
        this.fileList = []
      }
      const footer = document.getElementById('ltms-chat-footer');
      const body = document.getElementById('ltms-chat-history')
      if (footer && body) {
        footer.style.height = 'fit-content';
        body.style.height = 'calc( 100% - 80px)'
      }

      //reply type defines whether its a customer reply or manager reply
      //1 is for customer reply ,2 is for manager reply
      var isCustomerReply = this.replyType && this.replyType.trim() == "1" ? true : false;
      var params = {}
      //if its a customer reply then sending 1 as commented by type
      var commentedByType = isCustomerReply ? 1 : 2;
      if (isCustomerReply) {
        //if its a customer reply then send user_id 
        params["user_id"] = _.get(this, "feedDetails.feed_by_id")
      }

      if (Helpers.hasProperty(this.messageToSend, "is_internal")) {
        params["is_internal"] = this.messageToSend.is_internal;
      }

      // Prepare Comment Data

      var username;
      // var loginDetail = JSON.parse(localStorage.getItem('QUERY_PARAM_OBJ'));
      var loginDetail = this.getDefaultAccess();
      // setting default name of the manager if not available
      if (this.loginResponse && this.loginResponse.manager) {
        if (this.loginResponse.manager.name) {
          username = this.loginResponse.manager.name;
        } else if (loginDetail.manager_type == 2 && !this.loginResponse.manager.name) {
          username = "Brand Manager";
        } else {
          username = "Group Manager";
        }
      } else {
        username = "You";
      }

      var data: any = {
        'comment_text': comment,
        "commented_by_type": commentedByType,
        'user': {
          'name': (this.brandDetails && this.brandDetails.reply_from_text) ? this.brandDetails.reply_from_text : username
          //'photo_url': (lwFeedResponseVm.responseData.brandDetail && lwFeedResponseVm.responseData.brandDetail.reply_from_logo) ? lwFeedResponseVm.responseData.brandDetail.reply_from_logo : "defaultLogo"
        },
        'created_date': new Date(),
        '_id': (new Date()).getTime(),//Utils.getProp(response, "data._id"),
        'attachments': attachments,
        'paramsForDBUpdate': {
          "feedId": this.feedDetails._id,
          "isCustomerReply": isCustomerReply,
          "comment": comment,
          "attachments": attachments,
          "isSocial": this.isSocial,
          "params": params
        }
      }
      this.replying = false;
      //Calls the post comment which calls comment post api from feedsbeta
      this.setData();

      // Update isNewComment to identify new comment in the array. Undo option occurs only for new comment.
      // If comment gets undo, the comment with isNewComment gets removed.
      data.isNewComment = true;
      const newMessage = Helpers.deepClone(data)
      if (newMessage.attachments && newMessage.attachments.length) {
        newMessage.attachments = this.prepareAttatchmentDetails(newMessage.attachments)
      }
      this.comments.push(newMessage);
      const element:any = document.getElementById('ltms-chat-messages');
      if(element){
        setTimeout(() => {
          element.scroll({ top: element.scrollHeight, behavior: 'smooth' });
        }, 100);
      }
        

      setTimeout(() => {

        // Wait for 30s then hide undo button
        // $(".lw-feed-chat-undo-comment-btn").hide();

        // If comment with isNewComment present in the array then update the db else, reset the array
        if (_.filter(this.comments, { "isNewComment": true }).length) {
          this.commentOnfeed(data.paramsForDBUpdate)
        } else {
          // this.comments = _.find(this.comments, (comment: any) => {
          //   return comment.isNewComment != true;
          // });
        }
        // Delay should be picked from brand config. Default will be 15 seconds    
      }, this.undotime);
    } else {
      // document.getElementById('toast').style.display = 'block';
      // $timeout(function() {
      //     document.getElementById('toast').style.display = 'none';
      // }, 1000);
      this.replying = false;
      this.comment = Helpers.deepClone(this.messageToSend.comment);
    }

  }


  getDefaultAccess() {
    const managerAccess = _.get(this.loginResponse, 'manager.manager_access', []);
    let accessArray =  _.filter(managerAccess, { account_id: this.brandDetails.account_id, has_dashboard_access: true, is_verified: true  });
    let access:any= {};
    
    if (!_.isEmpty(accessArray)) {
      const defaultAccess = _.find(accessArray, { brand_id: this.brandDetails._id, is_default_access: true});
      const accountAccesses = _.filter(accessArray, {manager_type: 3});
      const prejectAccesses = _.filter(accessArray, { brand_id: this.brandDetails._id})
      if (!_.isEmpty(defaultAccess)) {
        access = defaultAccess
      }else if(!_.isEmpty(prejectAccesses)){
        access = prejectAccesses[0];
      } else if(!_.isEmpty(accountAccesses)){
        access = accountAccesses;
        access.reply_back_allowed = true
      }
    }
    return access;
  }

  commentOnfeed(data: any) {
    this.comments = _.map(this.comments, (message: any) => {
      message.isNewComment = false;
      return message
    })
    this._feedService.commentOnFeed(data).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((response) => {
      if (response && response.code == 403) {
        Helpers.showAuthorizationErr();
        //Handle the user previledges error if manager don't have previledges to comment or reply.
      } else if (response && response.code == 4055) {
        // Helpers.smallAlertBox("Error","You don't have access to reply on feed.", "error", 3000);
        this.notification("You don't have access to reply on feed.");
      } else {

        this.notification("Message sent successfully");
        // Data saved successfully
      }
    }, (error) => {
      this.notification("we are unable to sent message.");
      console.error("we are unable to sent message.", error);
    });
  }

  downloadAttachment(attachment: string) {
    this._feedService.downloadAttachment(attachment, this.brandDetails._id)
  }

  getUndoTimeString(time_in_ms: number) {
    var minutes = Math.floor(time_in_ms / 60000);
    var seconds = parseInt(((time_in_ms % 60000) / 1000).toFixed(0));
    let timestring: string = ''
    if (minutes > 0) {
      timestring += minutes + " minutes "
    }
    if (seconds > 0) {
      timestring += (seconds < 10 ? '0' : '') + seconds + " seconds"
    }
    return timestring;
  }
}

